import React from 'react'

import { IService } from '../interfaces/IService'
import { ServiceListItem } from './ServiceListItem'

export interface ServicesListProps {
  services: readonly IService[]
}

export const ServicesList = ({ services }: ServicesListProps) => {
  return (
    <ul className="grid gap-y-20 grid-cols-1">
      {!!services.length &&
        services.map((service) => {
          return <ServiceListItem key={service.id} {...service} />
        })}
    </ul>
  )
}
